import React from "react";
import ReferenceBuilder from "./ReferenceBuilder";
import ViewHeader from "./ViewHeader";
import { AssemblyType } from "../types/assembly-model";
import { AssemblyReferenceWriteModel } from "../types/assembly-reference";

interface AddReferenceViewProps {
  assemblyType: AssemblyType;
  assignedGroupObjectIdentifier?: string;
  onBack: () => void;
  onSubmit: (model: AssemblyReferenceWriteModel, promptLabel: string) => Promise<void>;
  loading: boolean;
  error: boolean;
}

const AddReferenceView = ({
  assemblyType,
  assignedGroupObjectIdentifier,
  onBack,
  onSubmit,
  loading,
  error,
}: AddReferenceViewProps) => {
  return (
    <div className="flex flex-col gap-4 px-3.5 pt-3">
      <ViewHeader title="New reference" onBack={onBack} />
      <ReferenceBuilder
        assemblyType={assemblyType}
        assignedGroupObjectIdentifier={assignedGroupObjectIdentifier}
        onSubmit={onSubmit}
        loading={loading}
        error={error}
        onClose={onBack}
      />
    </div>
  );
};

export default AddReferenceView;
